import axios from "axios";
import { store } from "../redux/store";
import { setLoading } from "../redux/features/slices/appSlice";
import { AuthApiService } from "../service/authService";

const getToken = async () => {
  const token = await AuthApiService.fetchAccessTokenFromCognitoSession();
  return token;
};

export const api = axios.create({
  baseURL: process.env.REACT_APP_BE_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

let lastRequestTime = 0;
const throttleDelay = 1000; // 1 second
let loaderTimeout: NodeJS.Timeout | null = null;
let requestCount = 0;

const throttledRequest = (isRequestStart: boolean) => {
  const now = Date.now();
  if (isRequestStart) {
    requestCount++;
    if (now - lastRequestTime > throttleDelay) {
      lastRequestTime = now;
      if (loaderTimeout) clearTimeout(loaderTimeout);
      if (requestCount === 1) store.dispatch(setLoading(true));
    } else console.warn("Request throttled, skipping...");
  } else {
    requestCount--;
    if (loaderTimeout) clearTimeout(loaderTimeout);
    loaderTimeout = setTimeout(() => {
      if (requestCount === 0) store.dispatch(setLoading(false));
    }, 300);
  }
};

api.interceptors.request.use(
  async (config) => {
    throttledRequest(true);
    const orgId = localStorage.getItem("orgId");
    const token = await getToken();
    if (
      config.headers &&
      config.headers["Content-Type"] === "application/json"
    ) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.Orgid = orgId;
    }
    return config;
  },
  (error) => {
    throttledRequest(false);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    throttledRequest(false);
    return response;
  },
  (error) => {
    throttledRequest(false);
    return Promise.reject(error);
  }
);
